import axios from "axios";
import { AxiosError } from "axios";
import { Dispatch } from "redux";
import { RootState } from "api/reducers";
import { Action } from "api/action_types/end_customer";
import { Action as AuthAction } from "api/action_types/authentication";
import { Action as QuoteAction } from "api/action_types/quote";
import { ActionType } from "api/action_types/end_customer";
import { ActionType as AuthActionType } from "api/action_types/authentication";
import { ICustomer } from "api/types/customer";
import { url_prefix } from "settings";
import { end_customer_url } from "../../endpoint";

export const createEndCustomer = (customer: ICustomer) => {
  return async (dispatch: Dispatch<Action | AuthAction | QuoteAction>, getState: () => RootState) => {

    const { user } = getState().authentication;

    dispatch({
      type: ActionType.CREATE_END_CUSTOMER_PENDING
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Token ${user.token}`
      }
    }

    const url = `${url_prefix}${end_customer_url}/`;

    try {
      const { data } = await axios.post(url, customer, config);

      dispatch({
        type: ActionType.CREATE_END_CUSTOMER_SUCCESS,
        payload: data
      });
    }
    catch (err) {
      if (err instanceof AxiosError) {
        dispatch({
          type: ActionType.CREATE_END_CUSTOMER_FAIL,
          payload: err.message
        });
        if (err && err.response && err.response.status === 401) {
          dispatch({
            type: AuthActionType.AUTH_FAILED
          });
        }
      }
    }
  }
}
